import RequestService from '../../../services/request-service';

/**
 * LCO-widget get web Manifest Request
 */
export default class GetWebManifestRequestService extends RequestService {
  /**
   * Class constructor method
   * @param {string} streamId - stream id
   * @param {1|2|3} providerId - stream provider id
   * @param {1|2|3|4} streamType - stream type enum
   */
  constructor(streamId, providerId = 1, streamType = 1) {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.getWebManifest;
    this.headers = this.$config.authorizationHeaders;
    /**
     * Set request method
     * @type {string}
     */
    this.method = 'get';

    /**
     * Set get params
     */
    this.getParams = {
      StreamId: streamId,
      StreamingIntegrationBrokerId: providerId,
      StreamType: streamType,
      ExternalUserId: APP_SETTINGS.player.id,
    };
  }
}
